import React from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import {TicketCard} from '@app/components/index';


function ModalVistaDashboard({show, hideModal, items,estado}) {
    const handleClose = () => hideModal();

    return (
        <Modal show={show} backdrop="false" onHide={handleClose} size="lg">
            <div className="container" style={{backgroundColor: '#f5f5f5'}}>
                <div className="col-12">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {`TICKETS ${estado}`}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="offset-lg-12 col-lg-12">
                                { items.length > 0 ?(
                                    items?.map((ticket)=>{
                                        return <TicketCard hideModal={hideModal} item={ticket} key={ticket.id_tk} className="mb-3" notHideModal hidenronom />
                                    })
                                ):(
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '48px 24px',
                                            color: '#aaa',
                                            gap: '12px',
                                        }}
                                    >
                                        <i className="fas fa-ticket-alt" style={{fontSize: '56px', opacity: 0.2}} />
                                        <p style={{margin: 0, fontWeight: 600, fontSize: '15px', color: '#888'}}>
                                            Sin tickets para este período
                                        </p>
                                        <p style={{margin: 0, fontSize: '12px', color: '#000'}}>
                                            No se encontraron tickets con estado
                                            {' '}
                                            <strong>{estado}</strong>
                                            {' '}
                                            en el período seleccionado.
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Modal.Body>
                </div>
            </div>
        </Modal>
    );
}

export default ModalVistaDashboard;
